import React from 'react'
import styled from 'react-emotion'
import { mediumMediaQuery } from 'utils/style-helpers'
import LinkButton from 'components/LinkButton'
import stepOneImg from './step-1.svg'
import stepTwoImg from './step-2.svg'
import stepThreeImg from './step-3.png'

const Container = styled.div`
  text-align: center;

  ${mediumMediaQuery} {
    text-align: right;
  }
`

const List = styled.ul`
  counter-reset: items;
  display: flex;
  flex-flow: row wrap;
  margin: 0;
  text-align: center;

  ${mediumMediaQuery} {
    justify-content: space-between;
  }
`

const Item = styled.li`
  list-style: none;
  margin: 0;
  padding: 25px 30px 30px 30px;
  position: relative;
  width: 100%;

  &::before {
    border: 4px solid #4caf50;
    border-radius: 9999px;
    box-sizing: content-box;
    color: #2c2c2c;
    content: counter(items);
    counter-increment: items;
    display: inline-block;
    font-size: 24px;
    height: 40px;
    left: 25px;
    line-height: 40px;
    position: absolute;
    top: 25px;
    width: 40px;
  }

  p {
    color: #545454;
    font-size: 20px;
    font-weight: 100;
    line-height: 1.2;
    margin: 25px 0 0 0;

    strong {
      font-weight: 900;
    }
  }

  ${mediumMediaQuery} {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 350px;
  }
`

const Image = styled.img`
  margin: 50px 0 0 0;
`

const ActionButton = styled(LinkButton)`
  width: 260px;
`

const HowItWorks = () => (
  <Container>
    <List>
      <Item>
        <Image src={stepOneImg} alt="step one" />
        <p>Snap your invoices</p>
      </Item>
      <Item>
        <Image src={stepTwoImg} alt="step two" />
        <p>We code invoices, organize docs and expenses and complete daily spend reports <strong>within hours</strong></p>
      </Item>
      <Item>
        <Image src={stepThreeImg} alt="step three" />
        <p>Sync your bills to accounting in real-time</p>
      </Item>
    </List>
    <ActionButton href="#sign-up">Learn More</ActionButton>
  </Container>
)

export default HowItWorks



// WEBPACK FOOTER //
// ./src/components/HowItWorks/index.js